import { render } from "./IconHeaderFavorite.vue?vue&type=template&id=1091b865&scoped=true"
const script = {}

import "./IconHeaderFavorite.vue?vue&type=style&index=0&id=1091b865&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1091b865"]])

export default __exports__